// Convert YYYY-MM-DD to DD/MM/YYYY
export const convertDateForReports = string => {
  return new Date(string).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
